import { ROLE_ADMIN, ROLE_MEMBER, ROLE_MODERATOR, ROLE_NONE, ROLE_OWNER } from "../constants";
export const allRoles = [ROLE_OWNER, ROLE_ADMIN, ROLE_MODERATOR, ROLE_MEMBER, ROLE_NONE];
export const chatRoles = allRoles;
export const communityRoles = [ROLE_OWNER, ROLE_ADMIN, ROLE_MEMBER];
export const messagePermissionsList = [
    "text",
    "image",
    "video",
    "audio",
    "file",
    "poll",
    "crypto",
    "giphy",
    "prize",
    "memeFighter",
    "p2pSwap",
];
// A bot's message permissions, in the order of the backend's MessagePermission bits. Unlike the
// group permissions above, they include video calls and MiniApp messages, and not Meme Fighter.
export const botMessagePermissionList = [
    "text",
    "image",
    "video",
    "audio",
    "file",
    "poll",
    "crypto",
    "giphy",
    "prize",
    "p2pSwap",
    "videoCall",
    "miniApp",
];
export const chatPermissionsList = [
    "changeRoles",
    "updateGroup",
    "inviteUsers",
    "addMembers",
    "removeMembers",
    "deleteMessages",
    "pinMessages",
    "reactToMessages",
    "tipMessages",
    "mentionAllMembers",
    "startVideoCall",
];
export const communityPermissionsList = [
    "changeRoles",
    "updateDetails",
    "inviteUsers",
    "removeMembers",
    "createPublicChannel",
    "createPrivateChannel",
    "manageUserGroups",
];
export const botChatPermissionList = [
    "changeRoles",
    "updateGroup",
    "addMembers",
    "inviteUsers",
    "removeMembers",
    "deleteMessages",
    "pinMessages",
    "reactToMessages",
    "mentionAllMembers",
    "startVideoCall",
    "readMessages",
    "readMembership",
    "readChatSummary",
];
export const botCommunityPermissionList = [
    "changeRoles",
    "updateDetails",
    "inviteUsers",
    "removeMembers",
    "createPublicChannel",
    "createPrivateChannel",
    "manageUserGroups",
    "readMembership",
    "readCommunitySummary",
];
export function defaultChatPermissions() {
    return {
        changeRoles: ROLE_ADMIN,
        removeMembers: ROLE_MODERATOR,
        deleteMessages: ROLE_MODERATOR,
        updateGroup: ROLE_ADMIN,
        pinMessages: ROLE_ADMIN,
        inviteUsers: ROLE_ADMIN,
        addMembers: ROLE_ADMIN,
        mentionAllMembers: ROLE_MEMBER,
        reactToMessages: ROLE_MEMBER,
        tipMessages: ROLE_MEMBER,
        startVideoCall: ROLE_MEMBER,
        messagePermissions: {
            default: ROLE_MEMBER,
            p2pSwap: ROLE_NONE,
        },
        threadPermissions: undefined,
    };
}
export function defaultOptionalChatPermissions() {
    return {
        messagePermissions: undefined,
        threadPermissions: undefined,
    };
}
export function defaultOptionalMessagePermissions() {
    return {
        default: undefined,
        text: undefined,
        image: undefined,
        video: undefined,
        audio: undefined,
        file: undefined,
        poll: undefined,
        crypto: undefined,
        giphy: undefined,
        prize: undefined,
        memeFighter: undefined,
        p2pSwap: undefined,
    };
}
